import type { KeyboardEvent } from 'react';
import type { RdLibraryDocument } from '@entities/mto';

/** Документ можно взять в ведомость: ПТО его разобрал. */
export function selectable(d: RdLibraryDocument): boolean {
  return d.ingest_status === 'indexed';
}

/** Почему документ нельзя выбрать — простым текстом. */
export function unavailableReason(d: RdLibraryDocument): string | null {
  switch (d.ingest_status) {
    case 'indexed':
      return null;
    case 'failed':
      return 'Не удалось разобрать — сообщите в ПТО.';
    default:
      return 'ПТО ещё разбирает документ — список обновится сам.';
  }
}

export function matchesSearch(d: RdLibraryDocument, q: string): boolean {
  if (!q) return true;
  const hay = `${d.code} ${d.title} ${d.source_filename} ${d.mark ?? ''}`.toLowerCase();
  return q
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .every((w) => hay.includes(w));
}

/** Enter в поле поиска не должен отправлять форму (создавать ведомость). */
export function noSubmitOnEnter(e: KeyboardEvent<HTMLInputElement>) {
  if (e.key === 'Enter') e.preventDefault();
}
